import styles from "./HeaderButton.module.css";
import type { ActionIconProps, PolymorphicFactory } from "@mantine/core";
import { ActionIcon, polymorphicFactory } from "@mantine/core";
import type { ComponentPropsWithoutRef } from "react";

type HeaderActionProps = ActionIconProps & ComponentPropsWithoutRef<"button">;

type HeaderActionIconFactory = PolymorphicFactory<{
  props: HeaderActionProps;
  defaultComponent: "button";
  defaultRef: HTMLButtonElement;
}>;

const HeaderActionIcon = polymorphicFactory<HeaderActionIconFactory>(({ ref, ...props }) => {
  return (
    <ActionIcon ref={ref} miw={32} {...props} className={styles.root}>
      {props.children}
    </ActionIcon>
  );
});

export default HeaderActionIcon;
